import { IsNotEmpty } from "class-validator";
import { DataValidationError } from "constants/DataValidationError";

export default class DeleteMessageBoardReq {
  @IsNotEmpty({
    message: DataValidationError.DATA_IS_EMPTY,
  })
  readonly messageBoardId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.messageBoardId = arg.messageBoardId;
  }
}
